import useProductChallengeAchievement from "hooks/product/useProductChallengeAchievement"

import AchievementSection from "components/presenters/commerce/product/productChallengeAchievement/AchievementSection"
import AchievementCard from "components/presenters/commerce/product/productChallengeAchievement/AchievementCard"
import AchievementInfo from "components/presenters/commerce/product/productChallengeAchievement/AchievementInfo"
import AchievementProgressBar from "components/presenters/commerce/product/productChallengeAchievement/AchievementProgressBar"
import DefaultEmpty from "components/presenters/commerce/product/productChallengeAchievement/DefaultEmpty"
import PaybackLink from "components/presenters/commerce/product/productChallengeAchievement/PaybackLink"

export default function AchievementContainer({ productNo }) {
  const {
    isParticipate,
    isPreparing,
    minAuth,
    maxAuth,
    currAuth,
    nickname,
    handleClickStartChallenge,
  } = useProductChallengeAchievement({
    productNo,
  })
  return isParticipate ? (
    isPreparing ? (
      <DefaultEmpty
        description={`제품을 받으셨다면\n인증시작 버튼을 눌러주세요`}
        callback={handleClickStartChallenge}
      />
    ) : (
      <AchievementSection>
        <AchievementCard>
          <AchievementInfo
            nickname={nickname}
            minAuth={minAuth}
            maxAuth={maxAuth}
            currAuth={currAuth}
          />
          <AchievementProgressBar minAuth={minAuth} maxAuth={maxAuth} currAuth={currAuth} />
        </AchievementCard>
        {currAuth >= 0 && minAuth && currAuth >= minAuth && <PaybackLink />}
      </AchievementSection>
    )
  ) : (
    <DefaultEmpty description={`환급 챌린지에 참여하고\n함께 뛰어보세요!`} />
  )
}
